import { render, staticRenderFns } from "./Accidents.vue?vue&type=template&id=6ecc50f3&scoped=true"
import script from "./Accidents.vue?vue&type=script&lang=js"
export * from "./Accidents.vue?vue&type=script&lang=js"
import style0 from "./Accidents.vue?vue&type=style&index=0&id=6ecc50f3&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecc50f3",
  null
  
)

export default component.exports